import loadable, { LoadableClassComponent } from '@loadable/component';
type Options = {
  ssr: boolean;
  fallback?: any
};

const dynamic = (
  lazyComponent: () => any,
  options: Options = { ssr: false }
) => {
  return loadable(lazyComponent, options) as LoadableClassComponent<any>;
};

export default dynamic;
